import React from 'react';

const OthersWentOnToBuy = () => {
  return <div id="dy-otherswentontobuy" className="text-neutral" />;
};

export default OthersWentOnToBuy;
